//import { Component, OnDestroy, OnInit, ViewEncapsulation,ChangeDetectorRef } from '@angular/core'
import {  PageService } from '../../services';
import { JSONRpcResponse } from "../../Interfaces/JSONRpcResponse";
import { Observable, of } from 'rxjs';
import { map, mapTo, tap } from 'rxjs/operators'

export class MenuConfig {
	private _codeGRoup:string="LISTE";
	
	
	public defaults: any = {
		header: {
			self: { display:true },
			items: [],
		},
		aside: {
			self: {display:true},
			items: [
				{
					title: "Tableau de bord",
					root: true,
					icon: "fas fa-home",
					page: "dashboard",
					translate: "MENU.DASHBOARD",
					right: '25146df4a7831432e5842a9802ce2a2f38aa894e',
					bullet: "dot"
				},
				{
					title: "Recherche",
					root: true,
					icon: "fas fa-search",
					page: "recherche",
					right: 'a62a7a3d235c34720bba36b65a056b4d3c6d005d'
					
				},
				
				{
				             title: 'Listes',
				             root: true,
				             icon: 'la la-list',
							 right: '735cf1665d0fd36f4865e4bc7439abe369572e04',
				             page: '',
							 
				             submenu: [
				                 {
				                     title: 'Actions collectives',
				                    root: true,
				                    icon: 'fas fa-handshake',
				                    page: 'actioncollective',
									right: '85bf28a1e4696c80cae663a48f0800537053ce3d',
				                 },
				                {
				                    title: 'Education à la sexualité',
				                    root: true,
				                    icon: 'fas fa-heart',
				                    page: 'aidesexualite',
									right: 'fa3b12bd0c2086cd25325e9d824cf2bb2039201f',
																		

				                 },
				                 {
				                    title: 'Enfants des écoles',
				                    root: true,
				                    icon: 'la la-school',
				                    page: 'bilan',
									right: '8fcd98dac77563c07a2112c4e6ef1be0a34a7e66',
																		
				                 }
				             ]
				 },				
				{
					title: "Séances",
					root: true,
					icon: "fas fa-comment-alt",
					page: "consultation",
					right: '61611711893e60e458b2087eadbffcf721d06193'
					
				},
				{
					title: "Nomade", 
					root: true,
					icon: "fas fa-info-circle",
					page: "nomade",
					right: '67494bd9c95826c2e720a553882e1cc378932bf4'
					
				},
				{
       				title: "Nouveau",
         		  	root: true,
          			icon: "fas fa-plus",
          			page: "nouveau",
					right: '66aabd91fc41cc4635aad94dc77d93a0e2eac67b',				
				},
			
			],
		},
	};
	
	private _pg:any;
	
	constructor(

			private pageService:PageService,
			
		) {
			this._pg=this.pageService;
		/*	let menuR = this.pageService.getMenuList({})
				 .subscribe((m:JSONRpcResponse) => {
			if (m.result) {
					this.defaults["aside"]["items"]=m.result;	*/
					//this.configs=this.defaults;									
		/*		let rep = this.pageService.listbygroup(this._codeGRoup, {});
												       rep.subscribe(r => {
														let cfgs:any=   this.defaults;
														      console.log("MenuConfig groupe",r,cfgs)
												let added:boolean=false;		
											    if (r.result) {
												       if (r.result.pages!=undefined  
														&& r.result.pages.length>0
														 && cfgs.aside!=undefined
														 && cfgs.aside.items!=undefined 
														 &&  cfgs.aside.items.length>2
													
													   ) {
														if (cfgs.aside.items[2].submenu==undefined)
															cfgs.aside.items[2].submenu=[];
														for(let i:number=0;i<r.result.pages.length;i++) {
															let page:any=r.result.pages[i];
															if (page.url!=undefined && page.url) {
																let mn:any=	{
								 				                    title: page.libelle,
								 				                    root: true,
								 				                    icon: 'la la-search',
								 				                    page: page.url,
								 									right: '8fcd98dac77563c07a2112c4e6ef1be0a34a7e66',
															 																		
																}
																
																cfgs.aside.items[2].submenu.push(mn);
																added=true;
															}
														}
														
													   }      
												      } else {
												              
												}
												console.log("MenuConfig groupe",r,cfgs)
												if (added) {
													this.defaults=cfgs;
												//	this.configs=this.defaults;
												}
												
												
				});
			*/		
					
				/*}
			});*/
		}	
		
	
	/* public  get configs() :any {
		return (async () => {
			const instructionS = await  this.pageService.getMenuList({}).toPromise();
			this.defaults["aside"]["items"]=instructionS.result;
			console.log("MenuConfig groupe after",this.defaults,instructionS)
			return this.defaults;
		
		}
		)();
		
		
	}*/
	public  get configs() :any {
		return this.defaults;
	}
	public   setItems(items:any[]) :any {
		this.defaults["aside"]["items"]=items
		return this.configs;
	}
	
	public  async getConfigs(){
		 const t= await this._pg.getMenuList({}).toPromise();
		 return t 	;	
		
	}
	
	public async  getConfigsOldd(){
							
					console.log("MenuConfig groupe before",this.defaults,this._pg);
				const called= await	this._pg.getMenuList({}).subscribe();
				//const response = await lastValueFrom(called);
				return called;
		}
		
	public  getConfigsOld(){
					
			console.log("MenuConfig groupe before",this.defaults,this._pg);
			this._pg.getMenuList({}).subscribe(instructionS => {
				this.defaults["aside"]["items"]=instructionS.result;
				console.log("MenuConfig groupe after222",this.defaults,instructionS)
			     return this.defaults;
			}	
			)
			//return this.defaults;
	}
	
	
	
}
